var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:['badge-outline-'+_vm.statusColor[_vm.status]]},[_vm._v(_vm._s(_vm.statusName ? _vm.statusName : _vm.$t(_vm.status)))])
}
var staticRenderFns = []

export { render, staticRenderFns }